/* @flow */

export const GridWidth = 4000;
export const GridHeight = 2127;
export const FloorHeight = GridHeight / 30;
export const SurfaceLineWidth = GridHeight / 200;
export const HeroSize = GridHeight / 5;
export const GoalWidth = GridWidth / 20;
export const GoalHeight = GridHeight / 50;
export const ParticleVerticalAcceleration = 2;
export const ParticleVerticalMaxSpeed = GridHeight / 50;
export const ParticleHorizontalSlowRate = 0.9;
export const ParticleHoseWidth = GridWidth / 14;
export const UmbrellaLength = ParticleHoseWidth * 1.2;
export const DefaultParticleHoseHeight = GridHeight + 100;

export interface Context {
  -fontSize: number;

  -fillStyle: string;
  -strokeStyle: string;
  -lineWidth: number;
  -textAlign: string;
  beginPath(): void;
  moveTo(number, number): void;
  lineTo(number, number): void;
  stroke(): void;
  fill(): void;
  fillText(string, number, number): void;
  strokeRect(number, number, number, number): void;
  fillRect(number, number, number, number): void;
  drawImage(Image, number, number, number, number, number, number, number, number): void;
}

export type Point = {
  x: number,
  y: number,
};

export type Tools = {
  ctx: Context,
};

export type SongSingleTrackConfig = {
  key: string,
  file: string,
};
export type SongLevelConfig = [SongSingleTrackConfig];
export type SongConfig = { [string]: SongLevelConfig };
export type SpriteAnimationStepConfig = {
  sheetPosition: Point,
  width: number,
  height: number,
  duration: number,
};
export type SpriteAnimationConfig = {
  file: string,
  steps: Array<SpriteAnimationStepConfig>,
};
export type SpriteConfig = { [string]: SpriteAnimationConfig };
export type GlobalConfig = {
  environment: string,
  assetsUrl: string,
  song: SongConfig,
  sprite: SpriteConfig,
};

export type TrackData = {
  elm: HTMLAudioElement,
  key: string,
  src: string,
  promise: Promise<void>,
};

export type DrawFunc = Tools => void;
export type StepFunc = () => void;
export type InputFunc = () => void;
export type MessageFunc = (Array<string>) => void;

export interface HasDraw {
  draw(Tools): void;
}
export interface HasStep {
  step(Tools): void;
}

export interface IsRamp {
  contains(Point): ?Point;
  bounce(Point): Point;
}

export interface ManageCanvas {
  cleanup(): void;
  subscribePlatform(DrawFunc): void;
  subscribeParticle(DrawFunc): void;
  subscribeHero(DrawFunc): void;
  subscribeRamp(DrawFunc): void;
  subscribeUmbrella(DrawFunc): void;
  subscribeGoal(DrawFunc): void;
  subscribeFloor(DrawFunc): void;
}

export interface ManageClock {
  cleanup(): void;
  subscribeInput(StepFunc): void;
  subscribeHero(StepFunc): void;
  subscribeParticle(StepFunc): void;
  subscribeGoal(StepFunc): void;
  subscribeLevel(StepFunc): void;
}

export interface ManageInput {
  cleanup(): void;
  subscribeMenuKeyPress(string, InputFunc): void;
  subscribeMenuKeyDown(string, InputFunc): void;
  subscribeLevelKeyPress(string, InputFunc): void;
  subscribeLevelKeyDown(string, InputFunc): void;
}

export interface ManageSong {
  cleanup(): void;
  loadSong(string): void;
  playTracks(Array<string>): void;
  muteTracks(Array<string>): void;
  setTracksVolume(Array<string>, number): void;
}
export interface ManageGlobal {
  canvas: ManageCanvas;
  clock: ManageClock;
  input: ManageInput;
  song: ManageSong;
  config: GlobalConfig;
  setMessageCenter: MessageFunc;
  setMessageTop: MessageFunc;
  cleanupLevel(): void;
}

export type LevelInfo = {
  name: string,
  key: string,
};

export type WorldInfo = {
  name: string,
  levels: Array<LevelInfo>,
};



// WEBPACK FOOTER //
// ./src/Common.js